// ./components/StatCard.jsx
import React, { memo } from "react";
import classNames from "classnames";

import { HandCoins } from 'lucide-react';

const StatCard = memo(({ label, icon, value, previousValue, impact, positiveColor = "#4caf50", negativeColor = "#f44336", color, onInvest, isSelected, isInvestDisabled, isBugVersion = false }) => {
  const hasImpact = impact !== undefined && impact !== null && Number(impact) !== 0;
  const valueClass = classNames("stat-value-final", {
    "stat-positive": hasImpact && impact > 0,
    "stat-negative": hasImpact && impact < 0,
  });
  const colorCard = "stat-card " + color;
  const isClickable = typeof onInvest === 'function' && !isInvestDisabled;

  const cardClasses = classNames(
    colorCard,
    {
      'cursor-pointer hover:scale-105 transition-transform duration-300': isClickable && !isBugVersion,
      'cursor-not-allowed opacity-50': typeof onInvest === 'function' && isInvestDisabled,
      'border-4 border-red-500 shadow-[0_0_30px_rgba(239,68,68,0.6)]': isBugVersion && isClickable,
    }
  );

  const handleClick = () => {
    if (isClickable && !isBugVersion) {
      onInvest(label);
    }
  };

  const handleIconClick = (e) => {
    if (isBugVersion && isClickable) {
      e.stopPropagation();
      onInvest(label);
    }
  };

  return (
    <div
      className={cardClasses}
      onClick={handleClick}
      title={isClickable ? `Investir dans ${label}` : ''}
    >
      <div className="stat-label">{icon} {label}</div>
      <div className="stat-value">
        {hasImpact ? (
          <>
            <span style={{ color: "grey", fontWeight: "bold" }}>{previousValue}</span>
            <span className="stat-arrow">→</span>
            <span className={valueClass} style={{ color: impact > 0 ? positiveColor : negativeColor, fontWeight: "bold" }}>
              {value}
            </span>
          </>
        ) : (
          <span className="text-right">{value}</span>
        )}
        {typeof onInvest === 'function' && (
          <div
            onClick={handleIconClick}
            className={`relative ml-2 p-2 rounded-full transition-all duration-300 transform group overflow-hidden
              ${isSelected
                ? 'bg-green-500 shadow-green-500/50'
                : 'bg-gradient-to-r from-yellow-500 to-amber-500 shadow-yellow-500/50'
              }
              ${isBugVersion ? 'animate-bug-pulse cursor-pointer ring-4 ring-offset-2 ring-red-500 shadow-[0_0_20px_rgba(239,68,68,0.8)]' : ''}
            `}
          >
            <HandCoins size="1em" className="text-black" />
          </div>
        )}
      </div>
    </div>
  );
});

export default StatCard;
